import React, { useState, useEffect } from 'react';
import './CreateTicket.css';
import zafClient from '../api/zendesk'
import { orderIDField } from '../contants'
import * as zendesk from '../api/zendesk'
import Loading from '../components/Loading'

export default function CreateTicket() {
    const [message, setMessage] = useState('')
    const [groupOptions, setGroupOptions] = useState([]);
    const [brandOptions, setBrandOptions] = useState([]);
    const [requesterOptions, setRequesterOptions] = useState();
    const [formOptions, setFormOptions] = useState([]);
    const [fieldOptions, setFieldOptions] = useState();
    const [formFields, setFormFields] = useState([]);
    const [subject, setSubject] = useState('');
    const [groupId, setGroupId] = useState('');
    const [formId, setFormId] = useState('');
    const [desc, setDesc] = useState('');
    const [brandId, setbrandId] = useState('');
    const [requesterId, setRequesterId] = useState('');
    const [customFields, setCustomFields] = useState({})
    const [priority, setPriority] = useState('');
    const [loaded, setLoaded] = useState(false);

    async function selectForm(e) {
        let arr = []
        let allFormField = await zendesk.getFormFieldsByFormId(e)
        for (let index = 0; index < allFormField.length; index++) {
            let intermediario = allFormField[index]
            for (let i = 0; i < fieldOptions.length; i++) {
                if (fieldOptions[i].id === intermediario) {
                    arr.push(fieldOptions[i])
                }
            }
        }
        setFormFields(arr)
    }

    function renderBrandsOptions() {
        if (brandOptions !== void (0)) {
            return brandOptions.map((e) => {
                return <option value={e.id}>{e.name}</option>
            })
        }
    }

    function renderGroupsOptions() {
        if (groupOptions !== void (0)) {

            return groupOptions.map((e) => {
                return <option value={e.id}>{e.name}</option>
            })
        }
    }

    function renderFormOptions() {
        if (formOptions !== void (0)) {
            return formOptions.map((e) => {
                return <option value={e.id}>{e.name}</option>
            })
        }
    }

    function renderUsersOptions() {
        if (requesterOptions !== void (0)) {
            return requesterOptions?.map((e) => {
                return <option value={e.id}>{e.name}</option>
            })
        }
    }

    function setCustomFieldSelectType(e) {
        const customFieldId = parseInt(e.target.value)
        const obj = {
            id: customFieldId,
            value: e.target.children[e.target.options.selectedIndex].label
        }
        const copy = JSON.parse(JSON.stringify(customFields))
        copy[customFieldId] = obj
        setCustomFields(copy)
    }


    function setCustomFieldInputType(e, fieldId) {
        fieldId = parseInt(fieldId)

        const copy = JSON.parse(JSON.stringify(customFields))
        copy[fieldId] = { id: fieldId, value: e.target.value }
        setCustomFields(copy)
    }

    function renderFormFields() {
        if (formFields !== void (0)) {
            return formFields.map(field => {
                if (field.position === 9999 || field.type === 'tickettype' || field.type === "priority") {

                    switch (field.type) {
                        case 'tagger':
                        case 'multiselect':

                            return (
                                <div className="select-container">
                                    <label>{field.title}</label>
                                    <select onChange={e => { setCustomFieldSelectType(e) }}>
                                        <option value=""></option>
                                        {field.custom_field_options.map(customField => (
                                            <option value={field.id}>{customField.value}</option>
                                        ))}
                                    </select>
                                </div>
                            )

                        case 'tickettype': // que ser isso?
                            return (
                                <div className="select-container">
                                    <label>{field.title}</label>
                                    <select onChange={e => { setCustomFieldSelectType(e) }}>
                                        <option value=""></option>
                                        {field.system_field_options.map(customField => (
                                            <option value={field.id}>{customField.value}</option>
                                        ))}
                                    </select>
                                </div>
                            )

                        case "priority":
                            return (
                                <div className="select-container">
                                    <label>{field.title}</label>
                                    <select onChange={e => { setPriority(e.target.children[e.target.options.selectedIndex].label) }}>
                                        <option value=""></option>
                                        {field.system_field_options.map(customField => (
                                            <option value={field.id}>{customField.value}</option>
                                        ))}
                                    </select>
                                </div>
                            )

                        case 'text':
                        case 'regexp':
                            return (
                                <div className="select-container">
                                    <label>{field.title}</label>
                                    <input type="text" onChange={e => { setCustomFieldInputType(e, field.id) }} />
                                </div>
                            )

                        case 'textarea':
                            return (
                                <div className="select-container">
                                    <label>{field.title}</label>
                                    <textarea onChange={e => { setCustomFieldInputType(e, field.id) }} />
                                </div>
                            )

                        case 'integer':
                        case 'decimal':
                            return (
                                <div className="select-container">
                                    <label>{field.title}</label>
                                    <input type="number" onChange={e => { setCustomFieldInputType(e, field.id) }} />
                                </div>
                            )

                        case 'checkbox':
                            return (
                                <div className="select-container">
                                    <input type="checkbox" style={{ width: 'auto', marginBottom: "0px" }} />
                                    <label style={{ marginLeft: "10px", fontSize: '12px' }}>{field.title}</label>
                                </div>
                            )

                        case 'date':
                            return (
                                <div className="select-container">
                                    <label>{field.title}</label>
                                    <input type="date" onChange={e => { setCustomFieldInputType(e, field.id) }} />
                                </div>
                            )
                    }
                } else {
                    return null
                }
            })
        }
    }

    async function createNewTicket() {
        const orderId = localStorage.getItem('order')
        const fieldList = Object.values(customFields)
        fieldList.push({ "id": orderIDField, "value": orderId })
        try {
            const resp = await zendesk.createTicket({
                "subject": subject,
                "description": desc,
                "custom_fields": [{ 'id': orderIDField, 'value': orderId }],
                "custom_fields": fieldList,
                "group_id": groupId,
                "brand_id": brandId,
                "priority": priority,
                "requester_id": requesterId,
                "ticket_form_id": formId
            })
            setMessage('Ticket Criado com sucesso!')

            return resp.ticket['id']
        } catch (e) {
            console.error("VTEX: ERROR:", e, e?.stack)
            setMessage("Ticket não criado, preencha todos os campos!")
            return 0
        }
    }

    useEffect(() => {
        async function getOptions() {
            const [groups, brands, fields, forms, requesterOptions] = await Promise.all([
                zendesk.getGroups(), zendesk.getBrands(), zendesk.getAllTicketFields(),
                zendesk.getForms(), zendesk.getZendeskUser()
            ])
            setGroupOptions(groups)
            setBrandOptions(brands)
            setFieldOptions(fields)
            setFormOptions(forms)
            setRequesterOptions(requesterOptions)
            setLoaded(true)
        }
        getOptions()

    }, [])
    if (!loaded) {
        return <Loading />
    }
    return (
        <div className="container-create-ticket">
            <header className="header-create-ticket">
                <img className="logo-create" alt="Logo da Vtex" src="https://upload.wikimedia.org/wikipedia/commons/a/a9/VTEX_Logo.svg" />
            </header>

            <div className="content-create-ticket">
                <div className="left-create-ticket">

                    <div className="select-container">
                        <label>Marca</label>
                        <select onChange={e => setbrandId(e.target.value)}>
                            <option></option>
                            {renderBrandsOptions()}
                        </select>
                    </div>

                    <div className="select-container">
                        <label>Solicitante</label>
                        <select onChange={e => setRequesterId(e.target.value)}>
                            <option></option>
                            {renderUsersOptions()}
                        </select>
                    </div>

                    <div className="select-container">
                        <label>Grupo</label>
                        <select onChange={e => setGroupId(e.target.value)}>
                            <option></option>
                            {renderGroupsOptions()}
                        </select>

                    </div>

                    <div className="select-container">
                        <label>Formulário</label>
                        <select onChange={(e) => { selectForm(e.target.value); setFormId(e.target.value) }}>
                            <option></option>
                            {renderFormOptions()}

                        </select>
                    </div>
                    {renderFormFields()}

                </div>
                <div className="right-create-ticket">
                    <div className="container-assunto">
                        <label>Assunto</label>
                        <input type="text" onChange={(e) => setSubject(e.target.value)} />
                    </div>
                    <div className="container-descricao">

                        <label>Descrição</label>
                        <textarea cols="30" rows="20" onChange={(e) => setDesc(e.target.value)}></textarea>
                    </div>
                </div>
            </div>
            <footer className="footer-create-ticket">
                <button onClick={() => zafClient.invoke('destroy')}>Cancelar</button>
                <button onClick={() => createNewTicket()}>Criar</button>
            </footer>
            <div className="confirmacao">{message}</div>
        </div>
    )
}
